// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var eq = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Maybe.eqMaybe(Data_Eq.eqString));
var apartmentNumberIsSymbol = {
    reflectSymbol: function () {
        return "apartmentNumber";
    }
};
var cityIsSymbol = {
    reflectSymbol: function () {
        return "city";
    }
};
var streetIsSymbol = {
    reflectSymbol: function () {
        return "street";
    }
};
var streetNumberIsSymbol = {
    reflectSymbol: function () {
        return "streetNumber";
    }
};
var StreetAddressWithApartmentIsSymbol = {
    reflectSymbol: function () {
        return "StreetAddressWithApartment";
    }
};
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons();
var encodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode);
var decodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons();
var decodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode);
var StreetAddressWithApartment = function (x) {
    return x;
};
var toFillFormTypeStreetAddre = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var newtypeStreetAddressWithA = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldStreetAddressWith = function (dictHasField) {
    return dictHasField;
};
var eqStreetAddressWithApartm = {
    eq: function (x) {
        return function (y) {
            return eq(x.apartmentNumber)(y.apartmentNumber) && x.city === y.city && x.street === y.street && x.streetNumber === y.streetNumber;
        };
    }
};
var genericStreetAddressWithApartment = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showStreetAddressWithApartment = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericStreetAddressWithApartment)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons(apartmentNumberIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(cityIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(streetIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(streetNumberIsSymbol)(Data_Show.showString))(Data_Show.showString))(Data_Show.showString))(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showString)))))(StreetAddressWithApartmentIsSymbol))
};
var unscrambleDecodeStreetAddressWithApartment = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericStreetAddressWithApartment)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons(apartmentNumberIsSymbol)(/* #__PURE__ */ Unscramble.decodeMaybe(Unscramble.decodeString1))(/* #__PURE__ */ Unscramble.decodeRecordCons(cityIsSymbol)(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons(streetIsSymbol)(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons(streetNumberIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordNil))))))))(Unscramble_Generic.defaultOptions)
};
var encodeStreetAddressWithApartment = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericStreetAddressWithApartment)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(StreetAddressWithApartmentIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(Foreign_Generic_Class.encodeRecordNil)(streetNumberIsSymbol)(encodeWithOptionsOther))(streetIsSymbol)(encodeWithOptionsOther))(cityIsSymbol)(encodeWithOptionsOther))(apartmentNumberIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode)))))))
};
var decodeStreetAddressWithApartment = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericStreetAddressWithApartment)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(StreetAddressWithApartmentIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(Foreign_Generic_Class.decodeRecordNil)(streetNumberIsSymbol)(decodeWithOptionsOther)())(streetIsSymbol)(decodeWithOptionsOther)())(cityIsSymbol)(decodeWithOptionsOther)())(apartmentNumberIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.stringDecode)))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
export {
    StreetAddressWithApartment,
    genericStreetAddressWithApartment,
    eqStreetAddressWithApartm,
    showStreetAddressWithApartment,
    encodeStreetAddressWithApartment,
    decodeStreetAddressWithApartment,
    unscrambleDecodeStreetAddressWithApartment,
    toFillFormTypeStreetAddre,
    hasFieldStreetAddressWith,
    newtypeStreetAddressWithA
};
